<button
  class="language__button"
  type="button"
  [disabled]="loading$ | async"
  (click)="initLanguagePicker()">
  <c-language-item
    [loading]="loading$ | async"
    [language]="selectedLanguage$ | async"
    variant="select" />
  <img src="assets/img/down.svg" [alt]="'common.alt-image' | transloco" />
</button>
